import moment from 'moment'
import React from 'react'
import { imageAddress, priceStandardView, translate } from '../../utils/useful'
import TLink from '../TLink'

class ServiceBox extends React.Component {

    state = {
        open: false
    }



    render() {

        let link = '/service/' + this.props.data._id

        // console.log(this.props.settings)
        return (
            <div className="w-100 service-box h-100 d-flex flex-column">
                <div className="w-100 cover-img-container m-0 p-0 flexcc">
                    <TLink className="m-0 p-0 w-100 h-100 flexcc" to={link}>
                        <img className="cover-img m-0 p-0" src={imageAddress(this.props.data.images)} alt="" style={{ filter: this.props.data.status == -1 ? 'saturate(5%)' : '' }} />
                    </TLink>
                </div>


                {/* <div className="mx-3 pt-2  pb-3 service-box-content">
                    <TLink to={link}><h3 className="font-bold text-small m-0">This is the title</h3></TLink>
                    <TLink to={link}><p className="service-box-desc text-smaller">This is the secription of the service</p></TLink>
                    <p className="text-small">Price: 30$</p>
                </div>

                <div className="flexcc service-box-actions mb-4">
                    <TLink className="py-2"><p className="text-small">Preview</p></TLink>
                </div> */}


                <div className="mx-3 pt-2  pb-2 service-box-content" style={{ flex: 1 }}>

                    <div className="text-end w-100">
                        <p className="mt-1 text-bold" style={{ fontSize: 12, color: '#9ab' }}>{moment(this.props.data.cDate).format('YYYY MMMM DD').toUpperCase()}</p>
                    </div>

                    <TLink to={link}>
                        <h3 className="font-bold text-semibig m-0">{this.props.data.name}</h3>
                    </TLink>
                    {/* <TLink to={link}><p className="service-box-desc text-smaller">{this.props.data.type}</p></TLink> */}

                    {this.props.data.description && (
                        <TLink to={link}><p className="mt-1" style={{ fontSize: 13 }}>{this.props.data.description}</p></TLink>
                    )}

                    {/* <p className=" text-uppercase mt-1 text-bold mb-1" style={{fontSize:12}}>Characteristics</p> */}

                    {/* <div className="flexc mt-2">
                        <div className="mrd-2" style={{ backgroundColor: '#f2f6f8', borderRadius: 4, padding: '5px 10px' }}>
                            <p className="  text-bold text-capitalize" style={{ fontSize: 11, color: '#567' }}>Type: {this.props.data.type}</p>
                        </div>
                    </div> */}

                    <div className="flexc mt-1 mb-1" style={{ flexWrap: 'wrap' }}>
                        {this.props.data?.structure?.map((prop, index) => {
                            if (prop.available) {
                                return (
                                    <div key={index} className="mrd-2" style={{ backgroundColor: '#f2f6f8', borderRadius: 4, padding: '5px 10px' }}>
                                        <p className="  text-bold text-capitalize" style={{ fontSize: 11, color: '#567' }}>{prop.label}</p>
                                    </div>
                                )
                            }
                        })}
                    </div>


                </div>

                <div className="flexcb service-box-actions  mx-3 pb-3 pt-3">
                    <div className="flexc">
                        {!this.props.settings?.edit && (
                            <TLink to={link} className="py-1 px-3 preview-but">
                                <p className=" text-bold text-capitalize">{translate("useful.preview")}</p>
                            </TLink>
                        )}
                        {this.props.settings?.edit && (
                            <button onClick={() => this.props.settings.openOptions(this.props.data)} className="py-1 px-3 preview-but mld-1">
                                <p className=" text-bold text-capitalize">{translate("useful.actions")}</p>
                            </button>
                        )}
                    </div>

                    <div>
                        <p className="text-normal text-bold service-box-price">{this.props.data?.price ?  priceStandardView(this.props.data?.price) +"C" : translate("Free")}</p>

                    </div>
                </div>

                <div style={{ top: 10, left: 10, position: 'absolute' }}>
                    <div className="blur-back px-2 py-1" style={{ borderRadius: 4, backgroundColor: '#000510aa' }}>
                        <p className="text-smaller white">{this.props.data.type} - {this.props.data.brand?.values?.name}</p>
                    </div>
                    {this.props.data.status == -1 && (
                        <div className="d-flex mt-1">
                            <div className="blur-back px-2 py-1" style={{ borderRadius: 4, backgroundColor: '#ee5050aa' }}>
                                <p className="text-smaller white">Disconnected</p>
                            </div>
                        </div>
                    )}

                    {this.props.data.private == true && (
                        <div className="d-flex mt-1">
                            <div className="blur-back px-2 py-1" style={{ borderRadius: 4, backgroundColor: '#2F4858aa' }}>
                                <p className="text-smaller white">Private</p>
                            </div>
                        </div>
                    )}

                </div>






            </div>
        )
    }
}

export default ServiceBox
